export default __webpack_public_path__ + "static/media/banner2.2cd81dd4.webp";